import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import Styles from './ProductUI.module.css'

export const COLOR_VARIANTS = ['green', 'blueLight', 'blueDark', 'orange', 'pink'] as const
export const SHADOW_POSITION_VARIANTS = ['left', 'left-bottom'] as const
export const corners = ['topLeft', 'topRight', 'bottomRight', 'bottomLeft'] as const

export interface ProductUIProps {
  className?: string
  shadowColor: (typeof COLOR_VARIANTS)[number]
  shadowPosition: (typeof SHADOW_POSITION_VARIANTS)[number]
  roundedCorners?: Partial<Record<(typeof corners)[number], boolean>>
  children: ReactNode
}

export const defaultProps: Partial<ProductUIProps> = {
  roundedCorners: {
    topLeft: true,
    topRight: true,
    bottomRight: true,
    bottomLeft: true,
  },
}

export const ProductUI = (props: ProductUIProps) => {
  const initializedProps: ProductUIProps = {...defaultProps, ...props}
  const {shadowColor, shadowPosition, roundedCorners, children, className} = initializedProps
  const computedRoundedCorners = {...defaultProps.roundedCorners, ...roundedCorners}

  return (
    <div
      className={clsx(
        Styles['ProductUI'],
        Styles[`ProductUI--${shadowColor}`],
        Styles[`ProductUI--shadow-${shadowPosition}`],
        corners.map(corner => computedRoundedCorners[corner] === false && Styles[`ProductUI--${corner}Square`]),
        className,
      )}
    >
      <div className={Styles.ProductUI__surface}>{children}</div>
    </div>
  )
}
